export default {
  appbar: {
    signupButton: "ثبت نام",
    loginButton: "ورود"
  },
  loginPage: {
    title: "ورود به اکسکوینو",
    emailOrMobile: {
      label: "شماره موبایل یا ایمیل",
      validation: "وارد کردن شماره موبایل یا ایمیل الزامی است"
    },
    mobile: {
      label: "شماره موبایل",
      validation: "وارد کردن شماره موبایل الزامی است"
    },
    email: {
      label: "ایمیل",
      validation: "وارد کردن ایمیل الزامی است"
    },
    password: {
      label: "رمز عبور",
      validation: {
        notEmpty: "وارد کردن رمز عبور الزامی است",
        notPersian: "رمز عبور را لاتین وارد کنید"
      }
    },
    forgetPasswordLink: "رمز عبور خود را فراموش کرده اید؟",
    loginButton: "ورود",
    signUpBefore: "قبلا ثبت نام نکرده اید؟",
    signUpBeforeLink: "ثبت نام کنید"
  },
  passwordRecoveryPage: {
    title: "بازیابی رمز عبور",
    emailOrMobile: {
      label: "شماره موبایل یا ایمیل",
      validation: "وارد کردن شماره موبایل یا ایمیل الزامی است"
    },
    passwordRecoveryButton: "ادامه"
  },
  passwordRecoveryOTPPage: {
    title: "بازیابی رمز عبور",
    subtitle: {
      part1: "برای بازیابی رمز عبور، کد ارسال شده به ",
      part2: " را وارد کنید."
    },
    otpCode: {
      placeholder: "کد تایید",
      validation: "وارد کردن کد تایید الزامی است"
    },
    timeTitle: " ارسال مجدد کد تا {count} ثانیه دیگر",
    passwordRecoveryOTPButton: "ادامه",
    passwordRecoveryOTPResendButton: "دریافت مجدد کد تایید"
  },
  passwordResetPage: {
    title: "تغییر رمز عبور",
    subtitle: "رمز عبور جدید خود را وارد کنید",
    password: {
      label: "رمز عبور",
      validation: {
        notEmpty: "وارد کردن رمز عبور الزامی است",
        notPersian: "رمز عبور را لاتین وارد کنید"
      }
    },
    passwordConfirm: {
      label: "تکرار رمز عبور",
      validation: "وارد کردن تکرار رمز عبور الزامی است"
    },
    passwordResetButton: "تایید",
    validationTitle: "ویژگی‌های رمز عبور:"
  },
  googleAuthPage: {
    title: "احراز هویت با گوگل",
    subtitle: "برای ورود، کد ۶ رقمی گوگل (Google Authenticator) را وارد کنید",
    otpCode: {
      placeholder: "Google Authenticator Code",
      validation: "وارد کردن کد تایید الزامی است"
    },
    googleAuthButton: "تایید و ورود"
  },
  emailAuthPage: {
    title: "احراز هویت با ایمیل",
    subtitle: {
      part1: "برای ورود، لطفا کد ارسال شده به (",
      part2: ") را وارد کنید."
    },
    otpCode: {
      placeholder: "کد تایید",
      validation: "وارد کردن کد تایید الزامی است"
    },
    emailAuthButton: "تایید و ورود"
  },
  otpAuthPage: {
    title: "احراز هویت با پیامک",
    subtitle: {
      part1: "برای ورود، لطفا کد ارسال شده به (",
      part2: ") را وارد کنید."
    },
    otpCode: {
      placeholder: "کد تایید",
      validation: "وارد کردن کد تایید الزامی است"
    },
    timeTitle: " ارسال مجدد کد تا {count} ثانیه دیگر",
    otpAuthButton: "تایید و ورود",
    otpAuthResetButton: "دریافت مجدد کد تایید"
  },
  registerPage: {
    title: "ثبت نام در اکسکوینو",
    emailOrMobile: {
      label: "شماره موبایل یا ایمیل",
      validation: "وارد کردن شماره موبایل یا ایمیل الزامی است"
    },
    password: {
      label: "رمز عبور",
      validation: {
        notEmpty: "وارد کردن رمز عبور الزامی است",
        notPersian: "رمز عبور را لاتین وارد کنید"
      }
    },
    passwordConfirm: {
      label: "تکرار رمز عبور",
      validation: "وارد کردن تکرار رمز عبور الزامی است"
    },
    referralCode: {
      title: "کد معرف (اختیاری)",
      label: "کد معرف"
    },
    policyLink: "با قوانین و شرایط",
    policyTitle: "اکسکوینو موافق هستم.",
    signUpButton: "ادامه",
    signInBefore: "قبلا ثبت نام کرده اید؟",
    signInBeforeLink: "وارد شوید",
    validationTitle: "ویژگی‌های رمز عبور:"
  },
  registerVerificationPage: {
    title: "ثبت نام در اکسکوینو",
    subtitle: {
      part1: "برای ثبت نام در اکسکوینو، لطفا کد ارسال شده به",
      part2: " را وارد کنید."
    },
    verificationCode: {
      placeholder: "کد تایید",
      validation: "وارد کردن کد تایید الزامی است"
    },
    timeTitle: " ارسال مجدد کد تا {count} ثانیه دیگر",
    verificationButton: "ثبت نام و ورود",
    verificationResetButton: "دریافت مجدد کد تایید"
  },
  registerConfirmedPage: {
    title: "اکانت شما در اکسکوینو ایجاد شد.",
    subtitle: "بطور خودکار بعد از {count} به صفحه ورود منتقل خواهید شد.",
    goToLoginButton: "ورود و تکمیل احراز هویت",
    completeAuth:
      "برای استفاده از تمام قابلیت‌های اکسکوینو، احراز هویت خود را تکمیل کنید."
  },
  emailVerifiedPage: {
    title: "ایمیل شما قبلا تایید شده است.",
    subtitle: {
      part1: "اگر سوالی دارید با",
      part2: "تماس بگیرید.",
      linkTitle: "پشتیبانی"
    },
    emailVerifiedButton: "ورود به حساب کاربری"
  },
  emailSuccessPage: {
    title: "ایمیل شما تایید شد",
    subtitle: "اکنون می‌توانید به حساب کاربری خود وارد شوید.",
    emailSuccessButton: "ورود به حساب کاربری"
  },
  emailInvalidPage: {
    title: "لینک فعال سازی نا معتبر است",
    subtitle: {
      part1: "اگر سوالی دارید با",
      part2: "تماس بگیرید.",
      linkTitle: "پشتیبانی"
    },
    emailInvalidButton: "ورود به حساب کاربری"
  },
  disableGaPage: {
    title: "غیرفعال سازی احراز هویت با گوگل",
    description:
      "کاربر گرامی، در صورت عدم دسترسی به شناسه دوعاملی، می توانید از طریق این صفحه اقدام به حذف شناسه دوعاملی از حساب کاربری خود نمایید. همچنین در صورت تکمیل این پروسه و حذف شناسه دوعاملی برداشت رمزارز حساب شما به مدت 72 ساعت محدود خواهد شد.",
    disableGA: "غیرفعال سازی احراز هویت با گوگل (Google Authenticator)",
    loginButton: "تایید و ورود",
    otpCode: {
      placeholder: "کد تایید"
    },
    loginToExcoino: "ورود به اکسکوینو",
    successMessage: "غیرفعال سازی احراز هویت با گوکل با موفقیت انجام شد",
    email: "ایمیل",
    mobile: "موبایل",
    forRegisterOtp: "برای ثبت‌نام، کد ارسال‌شده به {count} را وارد کنید"
  }
};
